import i18n from '../i18n';

/**
 * 获取多语言文本的工具函数
 * @param texts 包含不同语言文本的对象
 * @param fallback 回退文本（可选）
 * @returns 当前语言的文本或回退文本
 */
export const getLocalizedText = (
  texts: {
    zh?: string;
    en?: string;
    es?: string;
    [key: string]: string | undefined;
  },
  fallback?: string
): string => {
  const currentLang = i18n.language;
  
  // 尝试获取当前语言的文本
  const currentLangText = texts[currentLang];
  if (currentLangText) {
    return currentLangText;
  }
  
  // 如果当前语言没有文本，尝试获取语言前缀匹配的文本
  const langPrefix = currentLang.split('-')[0];
  const prefixText = texts[langPrefix];
  if (prefixText) {
    return prefixText;
  }
  
  // 如果都没有，尝试获取英文文本作为默认回退
  if (texts.en) {
    return texts.en;
  }
  
  // 最后使用传入的回退文本或空字符串
  return fallback || '';
};

/**
 * 获取异常字典的本地化文本
 * @param action 异常字典对象
 * @returns 当前语言的异常类型文本
 */
export const getExceptionTypeText = (action: {
  secondaryTypeZh: string;
  secondaryTypeEn: string;
  secondaryTypeEs?: string;
}): string => {
  return getLocalizedText({
    zh: action.secondaryTypeZh,
    en: action.secondaryTypeEn,
    es: action.secondaryTypeEs,
  }, action.secondaryTypeEn); // 使用英文作为默认回退
};

/**
 * 获取当前语言代码
 * @returns 当前语言代码
 */
export const getCurrentLanguage = (): string => {
  return i18n.language;
};


